window.addEventListener('DOMContentLoaded', () => {
  const pressRoomCarouselPageButtons = document.querySelectorAll('.press-room-carousel-page button');
  const pressRoomCarouselItems = document.querySelectorAll('.press-room-carousel-top ul li');

  let pressRoomCarouselCurrentPosition = 0;

  pressRoomCarouselPageButtons[0].classList.add('press-room-carousel-page-button-active');

  pressRoomCarouselPageButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const index = btn.dataset.index;
      pressRoomCarouselCurrentPosition = index;

      pressRoomCarouselPageButtons.forEach((b) => {
        b.classList.remove('press-room-carousel-page-button-active');
      });

      btn.classList.add('press-room-carousel-page-button-active');
      pressRoomCarouselItems[index].scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  })

  const pressRoomCarouselLeftButton = document.getElementById('press-room-carousel-controls-left');
  const pressRoomCarouselRightButton = document.getElementById('press-room-carousel-controls-right');

  pressRoomCarouselLeftButton.addEventListener('click', () => {
    pressRoomCarouselCurrentPosition -= 1;
    if (pressRoomCarouselCurrentPosition < 0) pressRoomCarouselCurrentPosition = 2;
    pressRoomCarouselItems[pressRoomCarouselCurrentPosition].scrollIntoView({ behavior: 'smooth', block: 'center' })

    pressRoomCarouselPageButtons.forEach((b) => {
      b.classList.remove('press-room-carousel-page-button-active');
    });

    pressRoomCarouselPageButtons[pressRoomCarouselCurrentPosition].classList.add('press-room-carousel-page-button-active');
  })

  pressRoomCarouselRightButton.addEventListener('click', () => {
    pressRoomCarouselCurrentPosition += 1;
    if (pressRoomCarouselCurrentPosition > 2) pressRoomCarouselCurrentPosition = 0;
    pressRoomCarouselItems[pressRoomCarouselCurrentPosition].scrollIntoView({ behavior: 'smooth', block: 'center' })

    pressRoomCarouselPageButtons.forEach((b) => {
      b.classList.remove('press-room-carousel-page-button-active');
    });

    pressRoomCarouselPageButtons[pressRoomCarouselCurrentPosition].classList.add('press-room-carousel-page-button-active');
  })
})
